<template>
  <div class="snapshot" v-loading="loading">
    <app-item-fake 
      :plans="plans" 
      :btnText="btnText" 
      :tabs="tabs"
      :id="this.$store.state.introStepInfo.currentStep===4?'guide-step4':'guide-step6'" 
      v-if="(this.$store.state.introStepInfo.currentStep===4
      ||this.$store.state.introStepInfo.currentStep===6)&&!this.$store.state.introStepInfo.complete_guide"
      :head_data="head_data"
      @setChartData="setChartData">
    </app-item-fake>
    <div class="app-list-wrap" v-if="applications.length>0">
      <div class="app-list-item" v-for="(item, index) in applications" :key="item.id">
        <div class="app-top">
          <div class="app-top-head">
            <div>
              <div></div>{{item.app_name}}
            </div>
            <div>
              <i class="iconfont icon-update hover-icon" @click="refreshApp(item,index)" :title="$t('messages.home.tip53')"></i>
              <i class="iconfont icon-android hover-icon" @click="goAppDetail(item)" :title="$t('messages.home.tip51')"></i>
              <i class="iconfont icon-delete hover-icon" @click="handleDeleteApp(item,index)" :title="$t('messages.home.tip54')"></i>
            </div>
          </div>
          <div class="app-top-body">
            <div class="body-desc1">
              <img :src="item.icon_url" class="body-logo" loading="lazy"/>
              <div class="body-desc1-rignt">
                <p class="multline">{{item.app_name}}</p>
                <div>
                  <i class="iconfont icon-update hover-icon" @click="refreshApp(item,index)"></i>
                  <i class="iconfont icon-android hover-icon" @click="goAppDetail(item)"></i>
                  <i class="iconfont icon-delete hover-icon" @click="handleDeleteApp(item,index)"></i>
                </div>
              </div>
            </div>
            <div class="body-desc">
              <div class="body-desc-left">
                <div>
                  <span>{{ $t('messages.home.tip27') }}</span>
                  <span>{{item.publisher}}</span>
                </div>
                <div>
                  <span>{{ $t('messages.home.tip28') }}</span>
                  <span>{{item.category}}</span>
                </div>
                <div>
                  <span>{{ $t('messages.home.tip52') }}</span>
                  <div>
                    <!-- <span>{{countryAll[item.country]}}</span> -->
                    <el-select
                      v-model="item.country"
                      size="medium"
                      style="width:168px;height: 40px;"
                      filterable
                      @change="refreshApp(item,index,1)"
                      :placeholder="$t('messages.other.other54')"
                    >
                      <el-option
                        v-for="(item, i) in countryOptions"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="body-desc-right">
                <div>
                  <span>{{ $t('messages.home.tip29') }}</span>
                  <span>{{item.install_times}}</span>
                </div>
                <div>
                  <span>{{ $t('messages.home.tip30') }}</span>
                  <span>{{item.reviews}}</span>
                </div>
                <div>
                  <span>{{ $t('messages.home.tip31') }}</span>
                  <div>
                    <el-rate
                      v-model="item.ratings"
                      disabled
                      show-score
                      text-color="#ff9900"
                      score-template="{value}"
                      :max="Number(5.0)"
                      >
                    </el-rate>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="app-tabs">
          <div :class="{'tab-item':true,'tab-item-active':index2===tabIndexs[index]}" v-for="(item2, index2) in tabs" :key="index2" @click="handleTab(item,index2,index)">
            <i :class="item2.icon"></i>
            <span>{{$t(`messages.home.${item2.titleLangKey}`)}}</span>
            <template v-if="index2===tabIndexs[index]">
              <span>:</span>
              <span style="color: #1861F2;margin-left: 4px;">{{item.running_campaigns}}</span>
            </template>
            <span v-if="index2===1" class="static-tab">{{ $t('messages.guide.guide10') }}</span>
          </div>
        </div>
        <div class="app-bot" v-if="tabIndexs[index]===0">
          <div class="app-bot-list">
            <div class="app-bot-item" v-for="(item2, index2) in plans" :key="index2">
              <div class="app-bot-item-top">
                <div :class="`dismantle${index2} el-progress`">
                 <el-progress :stroke-width="16" type="circle" :format="(per)=>getTip(per,index2)" :percentage="getPercent(index,index2)" class="tab1"></el-progress>
                 <progress-color style="width: 0;height: 0;"></progress-color>
                </div>
                <div class="item-p-wrap">
                  <p class="item-p">
                    <span :class="`itemSpan${index2}`"></span>
                    <span>{{ $t('messages.home.tip32') }} {{getAchieved(index,index2)}}</span>
                  </p>
                  <p class="item-p2">
                    <span></span><span>{{getSubTip(index,index2)}}</span> <i class="iconfont icon-a-Union2" style="color: #D0D3D9;" @mouseenter="showPop(index2)" @click="showPop(index2)"></i>
                  </p>
                </div>
              </div>
              <div :class="`item-btn btn-${index2}`" id="firstBtn" @click="handleBtn(item,index2)">{{$t(`messages.other.${btnText[index2]}`)}}</div>
            </div>
          </div>
          <div class="item-tips" v-if="installOver||reviewOver||rateOver">
            <p>{{ $t('messages.home.tip69') }}</p>
            <p style="margin-bottom: 8px">{{ $t('messages.home.tip22') }}</p>
            <p>{{ $t('messages.home.tip59') }} <span @click="handleContact(item,0)">{{ $t('messages.home.tip23') }}</span>{{ $t('messages.home.tip60') }}</p>
          </div>
        </div>
        <div class="app-bot-static" v-if="tabIndexs[index]===1">
          <div class="ym-board">
            <div class="board-data">
              <div
                class="detail-data"
                :key="index"
                v-for="(data, index) in head_data"
                :style="{
                  borderLeftColor: data.color,
                  borderLeftWidth: '4px',
                  borderLeftStyle: 'solid',
                }"
              >
                <div class="detail-label">{{ data.name }}</div>
                <div class="detail-val">
                  {{formatData(item[data.key], ',')}}
                </div>
              </div>
          </div>
          <div :id="`chart_${index}`" class="chart_css"></div>
          <div class="chart_no_data" v-if="showNoData(index)">
            <p>{{ $t('messages.other.other56') }}</p>
            <p>{{ $t('messages.other.other57') }} 
              <a style="text-decoration: underline;" @click="goCreate(item)">{{ $t('messages.other.other58') }}</a> {{ $t('messages.other.other59') }}</p>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-app-box" id="guide-step3">
      <div class="add-app-head">
        <span>{{ $t('messages.home.tip18') }}</span>
      </div>
      <add-app-com ref="addAppComRef" @callback="getAppList" :btnText="$t('messages.home.tip21')"></add-app-com>
    </div>
  
    <el-dialog class="pay-list" :visible.sync="popVisible" width="600px">
      <div class="pay-list-body">
        <div class="pay-list-item">
          <div class="question">{{$t(`messages.home.${popTitle[popIndex]}`)}}</div>
          <div class="answer">
            <div v-if="popIndex===0">{{ $t('messages.home.tip38') }}</div>
            <div v-if="popIndex===1">{{ $t('messages.home.tip43') }}</div>
            <template v-if="popIndex===2">
              <div style="margin-bottom: 10px;">{{ $t('messages.home.tip48') }}</div>
              <div style="margin-bottom: 10px;">{{ $t('messages.home.tip49') }}</div>
              <div>{{ $t('messages.home.tip50') }}</div>
            </template>
            <table v-if="popIndex!==2">
              <thead>
                <tr>
                  <th>{{ $t('messages.home.tip56') }}</th>
                  <th>{{ $t('messages.home.tip55') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('messages.home.tip56') }}1</td>
                  <td>{{popIndex===0?'20000':'1000'}}</td>
                </tr>
                <tr>
                  <td>{{ $t('messages.home.tip56') }}2</td>
                  <td>{{popIndex===0?'50000':'2500'}}</td>
                </tr>
                <tr>
                  <td>{{ $t('messages.home.tip56') }}3</td>
                  <td>{{popIndex===0?'100000':'5000'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pay-list-item" v-if="popIndex!==2">
          <div class="question" style="margin-top: 16px;">{{$t(`messages.home.${popFootTitle[popIndex]}`)}}</div>
          <div class="answer">
            <template v-if="popIndex===0">
              <div style="margin-bottom: 10px;">{{ $t('messages.home.tip40') }}</div>
              <div >{{ $t('messages.home.tip41') }}</div>
            </template>
            <template v-if="popIndex===1">
              <div style="margin-bottom: 10px;">{{ $t('messages.home.tip45') }}</div>
              <div>{{ $t('messages.home.tip46') }}</div>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { countryAll, countryAllCN } from '@/js/varible'
import progressColor from '../components/progressColor.vue';
import { debounce } from 'lodash'
import addAppCom from '../components/addAppCom.vue';
import appItemFake from '../components/appItemFake.vue';
import * as echarts from 'echarts';
import { guide } from '@/js/intro'
export default {
  components: {
    progressColor,
    addAppCom,
    appItemFake,
  },
  data() {
    return {
      // btnText:['Get more organic users','Get more good reviews','Improve your ratings'],
      btnText: ['other28','other29','other30'],
      popTitle:['tip37','tip42','tip47'],
      // popFootTitle:['Why your app need a lot of downloads?','Why your app need more positive reviews?'],
      popFootTitle: ['tip39','tip44'],
      // subTitle:['You need enough downloads to make your app more searchable and increase your keyword coverage.',
      //          'The more downloads and user engagement your app has, the better its rank position will be.'],
      // subTitle2:['Many users rely on reviews and ratings of the app to choose which application to install. Thus, your app should target on having more positive reviews.',
      //           'When the number of reviews reaches the specified level goal, the rates will tend to be stable and not easily modified.'],
      popIndex:0,
      popVisible:false,
      loading: false,
      countryAll,
      tabs:[
        {
          icon:'iconfont icon-promotion',
          titleLangKey: 'tip26'
        },
        {
          icon:'iconfont icon-statistics',
          titleLangKey: 'tip25'
        },
        {
          icon:'iconfont icon-campaign1',
          titleLangKey: 'tip24'
        },
      ],
      tabIndexs:[],
      applications:[],
      plans:[
        {
          achieved:40000,
          goal:100000,
          total: 100000,
        },
        {
          achieved:2500,
          goal:5000,
          total: 5000,
        },
        {
          achieved:4.1,
          goal:5,
          total:5,
        },
      ],
      rateOver:false,
      installOver:false,
      reviewOver:false,
      // countryOptions: this.initSelectOptions(countryAll),
      Chart: {},
      chartHistories: {},
      all_data:[],
      // head_data: [
      //   {
      //     name:'Installs',
      //     key:'install_times',
      //     color:'#1861F2',
      //   },
      //   {
      //     name:'Reviews',
      //     key:'reviews',
      //     color:'#FAAB35',
      //   },
      //   {
      //     name:'Ratings',
      //     key:'ratings',
      //     color:'#2BC9A3',
      //   },
      // ],
      chartNotDataShow:[],
    }
  },
  created() {
    let query = this.$route.query
    this.getAppList('init')
    if(query.fir){
      window.gtag('event', 'registerSuccess', { event_category: 'register' })
    }
    this.$EventBus.$on('handleAddApp', () => {// 监听事件
      this.handleAddAppAction()
    })  
    window.addEventListener('resize', debounce(this.handleDomCss,50))
    this.$nextTick(()=>{
      if(query.type==='add'){
        this.handleAddAppAction()
      }
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('handleAddApp');
    window.removeEventListener('resize', this.handleDomCss);
  },
  computed: {
    ...mapGetters(['settings']),
    head_data(){
      let list = [
        {
          name:this.$t('messages.home.tip29'),//'Installs'
          key:'install_times',
          color:'#1861F2',
        },
        {
          name:this.$t('messages.home.tip30'),
          key:'reviews',
          color:'#FAAB35',
        },
        {
          name:this.$t('messages.home.tip31'),
          key:'ratings',
          color:'#2BC9A3',
        },
      ]
      return list
    },
    countryOptions(){
      if(this.$i18n.locale === 'en'){
        return this.initSelectOptions(countryAll)
      }
      return this.initSelectOptions(countryAllCN)
    },
  },
  methods: {
    handleThankDetail(){
      this.$router.push({path:'/deposit',query:{type:'thank'}})
      this.$EventBus.$emit('scrollThank')
    },
    showNoData(index){
      let data = this.chartNotDataShow
      return data[index].installs&&data[index].reviews&&data[index].ratings
    },
    goCreate(row){
      this.$router.push({ path: '/campaign/create', query: { 
        url:row.app_store_url,
        country:row.country,
      }})
    },
    handleAddAppAction(){
      let dom = document.getElementById('guide-step3');
      let scrollBody = document.getElementById('elMain')
      scrollBody.scrollTop = dom.offsetTop + 62
      if(this.$refs.addAppComRef){
        this.$refs.addAppComRef.$refs.addAppInputRef&&this.$refs.addAppComRef.$refs.addAppInputRef.focus()
      }
    },
    handleDomCss(){
      this.$nextTick(() => {
        let dom = document.getElementById('firstBtn')
        let dom2 = document.getElementsByClassName('app-bot-item')[0]
        let tips = document.getElementsByClassName('item-tips')
        for (var i = 0; i < tips.length; i++) {
          let left = (dom2.offsetWidth - dom.offsetWidth) / 2
          tips[i].style.marginLeft = `${left}px`
        }
      })
    },
    handleBtn(item,index2){
      let types = [1,4,3]
      let caps = [100,50,100]
      let url = item.app_store_url;
      let country = item.country;
      let businessType = types[index2]
      let dailyCap = caps[index2]
      this.$router.push({ path: '/campaign/create', query: { 
        url,
        country,
        businessType,
        dailyCap,
      }})
    },
    handleTab(item,index2,index){
      if(index2===2){
        this.$router.replace(`/campaign/list?package=${item.package}`)
      }else if(index2===1){
        this.$set(this.tabIndexs,index,index2)
        this.$nextTick(()=>{
          this.getViewChart(index,item)
        })
      }else{
        this.$set(this.tabIndexs,index,index2)
        this.handleDomCss()
      }
    },
    getViewChart(index,row){
      this.loading = true
      let params = {
        app_id:row.id,
      }
      this.$http
        .get('/api/applications/history/',{
          params,
        })
        .then(res => {
          this.loading = false
          if(res.data.histories){
            this.setChartData(res.data.histories,index)
          }
        })
        .catch(()=>{
          this.loading = false
        })
      
    },
    setDefaultData(data,type,chartIndex,campaginFlag){
      type = type === 'install_times' ? 'installs' : type
      let arr = []
      let firstIndex = data.findIndex(item=>item>0)
      let lastIndex = data.findLastIndex(item=>item>0)
      // record_type.toLowerCase().includes("campagin")
      if(firstIndex === lastIndex){
        arr = data.map(()=>null)
        if(campaginFlag){
          arr[firstIndex] = data[firstIndex]
        }else if(chartIndex!=='fake'){
          this.changeChartNotData(type,chartIndex)
        }
      }else{
        data.map((item,index)=>{
          if(index >= firstIndex){
            if(Number(item) === 0 && index !== 0){
              arr.push(arr[index-1])
            }else{
              arr.push(item)
            }
          }else{
            arr.push(null)
          }
          if(!campaginFlag && chartIndex!=='fake'){
            arr = data.map(()=>null)
            this.changeChartNotData(type,chartIndex)
          }
          return item
        })
      }
      return arr
    },
    changeChartNotData(type,chartIndex){
      let obj = this.chartNotDataShow[chartIndex]
      obj[type] = true
      this.$set(this.chartNotDataShow,chartIndex,obj)
    },
    setChartData(data, index) {
      this.$set(this.chartHistories, index, data)
      this.setTable(data, index)
    },
    refreshChartsOnLocaleChange() {
      this.$nextTick(() => {
        Object.keys(this.chartHistories).forEach(chartIndex => {
          const index = chartIndex === 'fake' ? 'fake' : Number(chartIndex)
          if (chartIndex !== 'fake' && this.tabIndexs[index] !== 1) {
            return
          }
          if (document.getElementById(`chart_${chartIndex}`)) {
            this.setTable(this.chartHistories[chartIndex], chartIndex)
          }
        })
      })
    },
    setTable(origin_data,chartIndex){
      let _this = this
      let chart = `chart_${chartIndex}`
      try {
        let option = {
          title: {
            right: 0,
            top: 0,
            subtext: this.$t('messages.other.other60'),
            subtextStyle: {
              align: 'right',
              color: '#c7cbd2',
            },
          },
          backgroundColor: '#FFFFFF',
          tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: function(params) {
              if(chartIndex==='fake'){
                return ''
              }
              let relVal = params[0].name
              let showIndex = params[0].dataIndex
              let showObj = origin_data[showIndex]
              let tip = showObj.record_type
              relVal +=  tip ?'：' + tip : ''
              for (let i = 0, l = params.length; i < l; i++) {
                let item = params[i]
                let val = item.value
                if (isNaN(val)) {
                  val = '-'
                }
                relVal +=
                  '<br/>' +
                  item.marker +
                  item.seriesName +
                  ' : ' +
                  (item.seriesName === 'revenues' ? '$' + val : val)
              }
              return relVal
            },
          },
          legend: {
            data: [],
            selected: {},
            top: '10%',
            right: '0%',
            show: true,
            itemGap: 30,
          },
          grid: {
            left: '3%',
            top: '80',
            right: '4%',
            bottom: '0',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#EEF0F6',
                width: 2,
                type: 'solid',
              },
            },
            axisLabel: {
              color: '#323339',
              fontSize: '12',
              fontWeight: 400,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#EEF0F6',
                width: 1,
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: '{value} ',
            },
            scale: true, // 自适应
          },
          color: ['#1861F2','#FAAB35','#2BC9A3'],
          series: [],
        }
        this.Chart[chart] = echarts.init(document.getElementById(chart));
        let key_data = ['install_times','reviews','ratings']
        this.Chart[chart].clear(this.option);
        for (let j = 0; j < key_data.length; j++){
          let objKey = key_data[j]
          let series = {
            name: j === 0 ? this.$t('messages.other.other61') : this.$t(`messages.other.${objKey}`),
            type: 'line',
            data: [],
          }
          let x_ticks = []
          for (let i = 0; i < origin_data.length; i++) {
            let itemObj = origin_data[i]
            series.data.push(Number(itemObj[objKey]))
            x_ticks.push(itemObj.dt)
          }
          option.xAxis.data = x_ticks
          option.legend.data.push(series.name)
          option.legend.selected[series.name] = objKey !== 'reviews' && objKey !== 'ratings'
          option.series.push(series)
          let campaginFlag = origin_data.some((row,i) => {
            let str = row.record_type
            let flag = str.toLowerCase().includes('campaign')
            return flag
          })
          series.data = this.setDefaultData(series.data,key_data[j],chartIndex,campaginFlag)
        }
      
        this.Chart[chart].setOption(option)
        window.addEventListener('resize', function() {
          _this.Chart[chart].resize()
        })
      } catch (error) {}
    },
    refreshApp(item,index,type=0){
      this.loading = true
      let params = {
        pre_info: item.app_store_url,
        country: item.country,
      }
      this.$http
        .get('/api/applications/gpinfo/', {
          params,
        })
        .then(res => {
          if(res.data.application){
            let obj = this.applications[index]
            let newObj = res.data.application
            let mergeObj = Object.assign(obj,newObj)
            mergeObj.ratings = Number(mergeObj.ratings)
            mergeObj.app_name = newObj.name
            this.$set(this.applications, index, mergeObj)
            let params2 = {
              ...params,
              ...res.data.application,
              app_store_url: params.pre_info
            }
            this.$http
              .post('/api/applications/create/', params2)
              .then(() => {
                this.loading = false
                if(type===0){
                  this.notifyOpen(this.$t('messages.createCampaign.create157'))
                  
                  if(this.tabIndexs[index]===1){
                    this.handleTab(item,1,index)
                  }
                }else{
                  document.getElementById('elMain').scrollTop = 0;
                  this.getAppList()
                }
              })
              .catch(error => {
                this.loading = false
                this.notifyOpen('Error', this.executeError(error), 'error')
              })
          }else{
            this.loading = false
          }
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },
    goAppDetail(item){
      window.open(item.app_store_url, '_blank')
    },
    handleDeleteApp(item,index){
      this.$confirm('Are you sure to delete?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.loading = true
          this.$http
            .get(`/api/applications/delete/?id=${item.id}`)
            .then(() => {
              // this.applications.splice(index,1)
              // this.tabIndexs.splice(index,1)
              this.getAppList()
              this.notifyOpen(this.$t('messages.createCampaign.create158'))
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              this.notifyOpen('Error', this.executeError(error), 'error')
            })
        })
        .catch(()=>{})
    },
    getAchieved(index,index2){
      let str;
      let obj=this.applications[index];
      if(index2 === 0){
        str = obj.install_times
      }else if(index2===1){
        str = obj.reviews
      }else{
        str = obj.ratings
      }
      return Number(str);
    },
    getSubTip(index,index2){
      let str,str1,str2;
      let tempObj = this.applications[index]
      let install_times = Number(tempObj.install_times)
      let reviews = Number(tempObj.reviews)
      let rates = Number(tempObj.ratings)
      if(index2 === 2){
        str = this.$t('messages.home.tip72')
        if(rates>=5){
          this.rateOver=true
        }
      }else if(index2 === 0){
        if(install_times < 20000){ 
          str1 = this.$t('messages.home.tip67')
          str2 = '20,000'
        }
        if(install_times>20000 && install_times  < 50000){
          str1 = this.$t('messages.home.tip68')
          str2 = '50,000'
        }
        if(install_times > 50000){
          str1 = this.$t('messages.home.tip36')
          str2 = '100,000'
          this.installOver=true
        }
      }else{
        if(reviews < 1000){
          str1 = this.$t('messages.home.tip67')
          str2 = '1,000'
        }
        if(reviews > 1000 && reviews < 2500){
          str1 = this.$t('messages.home.tip68')
          str2 = '2,500'
        }
        if(reviews > 2500){
          str1 = this.$t('messages.home.tip36')
          str2 = '5,000'
          this.reviewOver=true
        }
      }
      if(index2!==2){
        str = str1 + str2
      }
      return str
    },
    getPercent(index,index2){
      let num = 0
      let obj = this.applications[index]
      let achieveds = ['install_times','reviews','ratings']
      let totals = [100000,5000,5]
      let achieved = Number(obj[achieveds[index2]])
      let total = totals[index2]
      num = Number(((achieved / total) * 100).toFixed(0))
      return num > 100 ? 100 : num ;
    },
    handleContact(item,type){
      if(type===0){
        this.$EventBus.$emit('showContact')
        this.OpenTawkChat()
      }else{
        this.handleBtn(item,1)
      }
    },
    showPop(index){
      this.popVisible = true
      this.popIndex = index
    },
    getTip(percentage,index){
      let arr = ['tip29','tip30','tip31']
      let str = percentage + '%' + '\n' + this.$t(`messages.home.${arr[index]}`)
      return str
    },
    getAppList(action){
      this.loading = true
      let query = this.$route.query
      this.$http
        .get('/api/applications/')
        .then(res => {
          this.loading = false
          if(res.data.applications){
            let indexs = []
            this.chartNotDataShow = []
            res.data.applications.map((item,index)=>{
              item.installOver = false
              item.reviewOver = false
              item.rateOver = false
              item.ratings = Number(item.ratings)
              indexs.push(0)
              this.Chart[`chart_${index}`] = null
              let obj = {
                installs:false,
                reviews:false,
                ratings:false,
              }
              this.chartNotDataShow.push(obj)
              return item
            })
            this.$nextTick(()=>{
              if(query.type==='add'&&action==='init'){
                this.handleAddAppAction()
              }
            })
            this.handleDomCss()
            this.applications = res.data.applications
            this.tabIndexs = indexs
          }
          this.$nextTick(()=>{
            if(query.type==='add'&&action==='init'){
              this.handleAddAppAction()
            }
          })
          // this.handleDomCss()
        })
        .catch(() => {
          this.loading = false
        })
    },
    goPage(pathName) {
      this.$router.push({ name: pathName })
    },
    handleGuide(step){
      this.$nextTick(()=>{
        if(step===3){
          guide([
            {
              title: this.$t('messages.home.tip18'),
              intro: `${this.$t('messages.guide.guide1')}(3/7)`,
              element: document.querySelector('#guide-step3'),
            },
          ])
        }else if(step===4){
          guide([
            {
              title: this.$t('messages.guide.guide2'),
              intro: `${this.$t('messages.guide.guide3')}(4/7)`,
              element: document.querySelector('#guide-step4'),
            },
          ])
        }else if(step===6){
          guide([
            {
              title: this.$t('messages.guide.guide6'),
              intro: `${this.$t('messages.guide.guide7')}(6/7)`,
              element: document.querySelector('#guide-step6'),
            },
          ])
        } 
      })
    },
  },
  watch: {
    '$i18n.locale'() {
      this.refreshChartsOnLocaleChange()
    },
    '$store.state.introStepInfo.currentStep': {
      handler(newVal,oldVal) {
        if(parseInt(sessionStorage.getItem('complete_guide'))) return;
        if(newVal === 3 && (oldVal===2 || oldVal===4)){
          this.handleGuide(3)
        }
        if(newVal === 4 && (oldVal===3 || oldVal===5||!oldVal)){
          this.handleGuide(4)
        }
        if(newVal === 6 && (oldVal===5 || oldVal===7||!oldVal)){
          this.handleGuide(6)
        }
        if(newVal===5 && oldVal === 6){
          this.$router.push('/campaign/create')
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.dismantle0 /deep/ .el-progress-circle,.dismantle1 /deep/ .el-progress-circle,.dismantle2 /deep/ .el-progress-circle{
  svg > path:nth-child(1) {
     stroke: #F0F3FA;
   }
}
.dismantle0 /deep/ .el-progress-circle {
   // 进度条颜色
   svg > path:nth-child(2) {
     stroke: url(#dismantle0);  // 该url() 中填入的是, 对应组件中的 id 名
   }
 }
 .dismantle1 /deep/ .el-progress-circle {
   // 进度条颜色
   svg > path:nth-child(2) {
     stroke: url(#dismantle1);  // 该url() 中填入的是, 对应组件中的 id 名
   }
 }
 .dismantle2 /deep/ .el-progress-circle {
   // 进度条颜色
   svg > path:nth-child(2) {
     stroke: url(#dismantle2);  // 该url() 中填入的是, 对应组件中的 id 名
   }
 }

</style>

<style lang="scss">
.snapshot {
  min-height: 85%;
  .ym-board{
    position: relative;
    .detail-label {
      text-transform: capitalize;
      font-size: 12px;
      font-weight: 400;
      color: rgba(155, 158, 163, 1);
    }
    .detail-val {
      font-size: 20px;
      font-weight: 500;
      color: rgba(55, 56, 58, 1);
    }
    .board-data {
      position: absolute;
      z-index: 9;
      padding-left: 28px;
    }
    .detail-data {
      display: inline-block;
      width: 200px;
      padding-left: 16px;
      height: 40px;
    }
  }
  .chart_css {
    height: 340px;
    width: 100%;
  }
  .chart_no_data{
    position: absolute;
    top: 170px;
    text-align: center;
    width: 100%;
    >p{
      color: #909399;
      &:first-child{
        font-size: 16px;
        margin-bottom: 8px;
      }
    }
  }
  .app-list-wrap {
    border-radius: 4px;
  }
  .add-app-box {
    padding: 24px;
    border: 2px dashed #E1E4EB;
  }
  .app-list-wrap,.add-app-box{
    margin-bottom: 24px;
  }
  .app-list-wrap{
    .app-list-item{
      margin-bottom: 16px;
      background: #fff;
      .app-top{
        padding: 16px 24px 24px;
        .app-top-head{
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #F0F3FA;
          padding-bottom: 8px;
          >div{
            &:first-child{
              display: flex;
              align-items: center;
              font-size: 16px;
              font-weight: 500;
              color: #606266;
              >div{
                width: 4px;
                height: 24px;
                background: #1861F2;
                margin-right: 8px;
              }
            }
            &:last-child{
              .hover-icon{
                font-size: 20px;
                margin-right: 22px;
                color: #D0D3D9;
                cursor: pointer;
                &:last-child{
                  margin-right: 0;
                }
                &:hover{
                  color: #1861F2;
                }
              }
            }
          }
        }
        .app-top-body{
          display: flex;
          align-items: center;
          width: 100%;
          padding-top: 16px;
          .body-desc1{
            .body-desc1-rignt{
              display: none;
            }
          }
          .body-logo{
            width: 96px;
            height: 96px;
            border-radius: 12px;
            margin-right: 40px;
          }
          .body-desc{
            display: flex;
            align-items: center;
            flex: 1;
            .body-desc-left,.body-desc-right{
              flex: 1;
              >div{
                margin-bottom: 8px;
                >span{
                  font-weight: 400;
                  line-height: 22px;
                  font-size: 14px;
                  &:first-child{
                    display: inline-block;
                    color: #909399;                  
                    margin-right: 38px;
                    display: inline-block;
                    width: 60px;
                  }
                  &:last-child{
                    display: inline-block;
                    height: 22px;
                    color: #303133;
                  }
                }
                &:last-child{
                  display: flex;
                  align-items: center;
                }
              }
            }
            .body-desc-left{
              >div{
                &:last-child{
                  >div{
                    display: flex;
                    align-items: center;
                    >img{
                      width: 24px;
                      height: 18px;
                      margin-right: 4px;
                    }
                    >span{
                      font-weight: 400;
                      line-height: 22px;
                      font-size: 14px;
                      color: #303133;
                    }
                  }
                }
              }
            }
            .body-desc-right{
              >div{
                &:last-child{
                  >div{
                    >img{
                      width: 21px;
                      height: 16px;
                    }
                    >span{
                      font-weight: 400;
                      line-height: 22px;
                      font-size: 14px;
                      color: #303133;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .app-tabs{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tab-item{
          height: 40px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          cursor: pointer;
          border: 1px solid #F0F3FA;
          border-left: none;
          >i{
            font-size: 20px;
            color: #D0D3D9;
            margin-right: 12px;
          }
          >span{
            font-size: 14px;
            font-weight: 400;
            color: #303133;
          }
          &:last-child{
            border-right: none;
          }
          .static-tab{
            background: #ff5967;
            color: #fff !important;
            text-align: center;
            padding: 4px;
            border-radius: 14px 10px 4px 14px;
            width: 38px;
            display: inline-block;
            font-weight: 600;
            margin-left: 4px;
          }
        }
        .tab-item:hover,.tab-item-active{
          background: rgba(24,97,242,0.08);
          >i,>span{
            color: #1861F2;
          }
        }
      }
      .app-bot{
        padding-top: 32px;
        padding-bottom: 32px;
        .app-bot-list{
          display: flex;
          justify-content: space-between;
          .app-bot-item,.app-bot-item-fake{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            .app-bot-item-top{
              text-align: center;
            }
            .el-progress__text {
              white-space: pre;// 使百分号与所添加文字换行
            }
            .item-p,.item-p2{
              font-size: 14px;
              font-weight: 400;
              color: #606266;
              line-height: 22px;
              margin-bottom: 4px;
              display: flex;
              align-items: center;
              >span{
                &:first-child{
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  border-radius: 50%;
                  margin-right: 4px;
                }
              }
              >i{
                margin-left: 4px;
              }
            }
            .item-p {
              margin-top: 12px;
              .itemSpan0{
                background: linear-gradient(180deg, #1861F2 0%, #BDD3FE 100%);
              }
              .itemSpan1{
                background: linear-gradient(180deg, #FAAB35 0%, #FFE7A8 100%);
              }
              .itemSpan2{
                background: linear-gradient(180deg, #38CBA8 0%, #B3EBDD 100%);
              }
            }
            .item-p2 {
              >span:first-child{
                background: #F0F3FA;
              }
            }
            .item-btn{
              height: 32px;
              border-radius: 4px;
              font-size: 14px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 22px;
              padding: 5px 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 8px;
              cursor: pointer;
            }
            .btn-0{
              background: #1861F2;
            }
            .btn-1{
              background: #FAAB35;
            }
            .btn-2{
              background: #2BC9A3;
            }
            
          }
        }
        .item-tips,.item-tips-fake{
          font-size: 14px;
          font-weight: 400;
          color: #606266;
          line-height: 22px;
          text-align: left;
          margin-top: 20px;
          p{
            line-height: 22px;
          }
          span{
            color:#1861F2;
            cursor: pointer;
          }
        }
      }
      .app-bot-static{
        padding: 25px 28px 25px 0;
      }
    }
  }
  .add-app-box{
    background: #fff;
    .add-app-head{
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      >span{
        &:first-child{
          height: 28px;
          font-size: 20px;
          font-weight: 500;
          color: #303133;
          line-height: 28px;
          margin-right: 24px;
        }
        &:last-child{
          height: 24px;
          font-size: 20px;
          font-weight: 400;
          color: #606266;
          line-height: 24px;
        }
      }
    }
  }
  .pay-list{
    .pay-list-body{
      .pay-list-item{
        .question {
          margin-bottom: 8px;
          font-weight: 600;
          font-size: 18px;
        }
        .answer {
          color: #6b6d71;
          font-size: 14px;
          line-height: 22px;
          border: 1px solid #ebeef5;
          padding: 16px 24px;
          background: #fafcff;
          // white-space: pre-line;
          overflow-x: auto;
          table {
            border-collapse: collapse;
            margin-top: 12px;
            th,td {
              border: 1px solid #ddd;
              text-align: center;
              padding: 4px 8px;
              width: 100px;
            }
            th{
              background: #eee;
            }
          }
        }
      }
    }
  }
}
.el-message-box.el-message-box--center .el-message-box__status.el-icon-warning{
  color:#e6a23c;
 }
 @media screen and (max-width: 901px) {
  .el-main{
    padding-left: 14px;
    padding-right: 14px;
  }
  .snapshot{
    min-height: 78%;
    .app-list-wrap{
      .app-top{
        .app-top-head{
          display: none !important;
        }
        .app-top-body{
          flex-direction: column;
          padding-top: 8px;
          .body-desc{
            width: 100%;
          }
          .body-desc1{
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            width: 100%;
            .body-desc1-rignt{
              display: flex !important;
              flex-direction: column;
              justify-content: space-around;
              height: 72px !important;
              >div{
              .hover-icon{
                font-size: 20px;
                margin-right: 22px;
                color: #D0D3D9;
                cursor: pointer;
                &:last-child{
                  margin-right: 0;
                }
                &:hover{
                  color: #1861F2;
                }
              }
              }
              >p{
                font-size: 16px;
                font-weight: 500;
                color: #606266;
                line-height: 24px;
              }
              .multline{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }

          }
          .body-logo{
            width: 72px !important;
            height: 72px !important;
            margin-right: 26px !important;
          }
          .body-desc{
            flex-direction: column;
            .body-desc-left,.body-desc-right{
              width: 100%;
            }
            .body-desc-right{
              >div:last-child{
                margin-bottom: 0 !important;
              }
            }
          }
        }
      }
      .app-tabs{
        display: none !important;
      }
      .app-bot{
        border-top: 1px solid #F0F3FA;
        .app-bot-list{
          flex-direction: column;
          padding: 0 24px;
          .app-bot-item,.app-bot-item-fake{
            .item-btn{
              width: 100% !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
              height: 22px !important;
              margin-bottom: 48px !important;
              margin-top: 24px !important;
            }
            .el-progress-circle{
              width: 100px !important;
              height: 100px !important;
            }
            .item-p2{
              >p{
                font-size: 14px !important;
              }
            }
            &:last-child{
              .item-btn{
                margin-bottom: 4px !important;
              }     
            }
            .item-p,.item-p2{
              >span:nth-child(2){
                text-overflow: ellipsis;     
                white-space: nowrap;     
                overflow: hidden;     
              }
            }
            .item-p{
              >span:nth-child(2){
                max-width: 160px;
              }
            }
            .item-p2{
              >span:nth-child(2){
                max-width: 140px;
              }
            }
          }
          .app-bot-item-top{
            display: flex;
            align-items: center;
            width: 100%;
            .item-p-wrap{
              width: 100%;
              margin-left: 14px;
            }
          }
        }
      }
    }
    .el-dialog{
      width: 330px !important;
    }
    .pay-list {
      .pay-list-body{
        .pay-list-item{
          .question{
            font-weight: 500;
            font-size: 16px !important;
          }
        }
      }
    } 
    .app-list-wrap{
      .app-list-item{
        .app-bot{
          .item-tips,.item-tips-fake{
            margin-left: 30px !important;
            width: 86% !important;
          }
        }
      }
    } 
  }
}
</style>

